


// src/api/createSocket.js
// import { io } from 'socket.io-client';

// export const createSocket = ({ path, headers }) => {
//       const authToken = process.env.REACT_APP_APPTOKEN;

//       const socket = io(process.env.REACT_APP_WS_ENDPOINT, {
//             path,
//             transports: ['websocket'],
//             query: {
//                   ...headers, // btoken, stoken, usertoken
//                   Authorization: `Bearer ${ authToken }`,
//             },
//       });

//       return socket;
// };


export const createSocket = ({ headers }) => {
      const authToken = process.env.REACT_APP_APPTOKEN;

      // Convert headers to query string
      const queryParams = new URLSearchParams({
            ...headers,
            Authorization: `Bearer ${ authToken }`,
      }).toString();

      const wsUrl = `${ process.env.REACT_APP_WS_ENDPOINT }?${ queryParams }`;

      const socket = new WebSocket(wsUrl);

      return socket;
};
